import React, { useState } from "react";
import styles from "./Orders.module.scss";
import { Container } from "reactstrap";
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow";
import { FaShippingFast, FaTruck } from "react-icons/fa";
import { FaBoxesPacking } from "react-icons/fa6";
import { BsFillBagCheckFill } from "react-icons/bs";
import { FaTruckLoading } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { RiArrowGoBackFill } from "react-icons/ri";
import { TbShoppingCartCancel } from "react-icons/tb";
import DynamicFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicFilterBar/DynamicFilterBar";
import DynamicDropdownButton from "../../../../components/common/AdminCommonComponents/Buttons/DynamicDropdownButton/DynamicDropdownButton";
import DynamicDatatable from "../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import ActionButton from "../../../../components/common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import StatusBadge from "../../../../components/common/AdminCommonComponents/StatusBadge/StatusBadge";
import { useNavigate } from "react-router-dom";
import { ordersTableData } from "../../dummyData";

const orders = [
    { title: "RECEIVED", value: 0, icon: <FaBoxesPacking size={32} color="#FBBD34" /> },
    { title: "CONFIRMED", value: 0, icon: <BsFillBagCheckFill size={28} color="#FBBD34" /> },
    { title: "SHIPPED", value: 0, icon: <FaTruck size={32} color="#FBBD34" /> },
    { title: "OUT FOR DELIVERY", value: 0, icon: <FaShippingFast size={32} color="#FBBD34" /> },
    { title: "DELIVERED", value: 0, icon: <FaTruckLoading size={32} color="#FBBD34" /> },
    { title: "CANCELLED", value: 0, icon: <MdCancel size={28} color="#FBBD34" /> },
    { title: "RETURNED", value: 0, icon: <RiArrowGoBackFill size={28} color="#FBBD34" /> },
    { title: "FAILED", value: 0, icon: <TbShoppingCartCancel size={32} color="#FBBD34" /> },
];

const tabsData = [
    { key: "1", label: "All" },
    { key: "2", label: "Pending" },
    { key: "3", label: "Ready to ship" },
    { key: "4", label: "Shipped" },
    { key: "5", label: "Delivered" },
    { key: "6", label: "Cancelled" },
    { key: "7", label: "Returned" },
    { key: "8", label: "Refund only" },
    { key: "9", label: "Failed delivery" },
];

const Orders = () => {
    const [activeTab, setActiveTab] = useState(tabsData[0]?.key || "");
    const navigate = useNavigate();

    const options = [
        { label: "View detail", action: () => navigate('/ordermanagement/orders/detail') },
        { label: "Update status", action: () => console.log("Update status") },
        { label: "Cancel", action: () => console.log("Cancel") },
        { label: "Generate invoice", action: () => console.log("Generate invoice") },
        { label: "Initiate Refund", action: () => console.log("Initiate Refund") },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Order ID",
            selector: (row) => row.id,
            center: "true",
            width: "150px",
        },
        {
            name: "Customer Name",
            cell: (row) => (
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <img
                        src={row.customerImage}
                        alt="customer"
                        style={{ borderRadius: "50%", width: "40px", height: "40px" }}
                    />
                    {row.customerName}
                </div>
            ),
            minWidth: "160px",
        },
        {
            name: "Total Payment",
            selector: (row) => row.totalPayment,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Last Order Update",
            selector: (row) => row.lastUpdate,
            center: "true",
            minWidth: "180px",
        },
        {
            name: "Status",
            cell: (row) => <StatusBadge statusName={row.status} />,
            center: "true",
        },
        {
            name: "Payment Status",
            cell: (row) => <StatusBadge statusName={row.paymentStatus} />,
            center: "true",
            minWidth: "160px",
        },
        {
            name: "Order Date",
            selector: (row) => row.orderDate,
            center: "true",
            minWidth: "120px",
        },
        {
            name: "Action",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleOptionSelect = (option) => {
        console.log("Selected Option:", option);
    };

    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderWrapper}>
                <h5 className={styles.mainHeading}>Orders</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={orders} />
                </div>
            </Container>
            <Container fluid className={styles.filterTableWrapper}>
                <div className={styles.filterDropdownWrapper}>
                    <DynamicFilterBar
                        filterTabs={tabsData}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        barType="default"
                    />
                    <div className={styles.dropdownButtonsRow}>
                        <DynamicDropdownButton
                            buttonName="Print"
                            dropdownOptions={[
                                { value: "pdf", label: "PDF" },
                                { value: "excel", label: "Excel" },
                            ]}
                            onOptionSelect={handleOptionSelect}
                        />
                        <DynamicDropdownButton
                            buttonName="Export"
                            dropdownOptions={[
                                { value: "csv", label: "CSV" },
                                { value: "json", label: "JSON" },
                            ]}
                            onOptionSelect={handleOptionSelect}
                        />
                        <DynamicDropdownButton
                            buttonName="View history"
                            dropdownOptions={[
                                { value: "today", label: "Today" },
                                { value: "last-week", label: "Last Week" },
                            ]}
                            onOptionSelect={handleOptionSelect}
                        />
                    </div>
                </div>
                <div className={styles.tableWrapper}>
                    <DynamicDatatable
                        data={ordersTableData}
                        columns={columns}
                        type="gray"
                        pagination
                        highlightOnHover
                        responsive
                    />
                </div>
            </Container>
        </div>
    );
};

export default Orders;